//EVEN LISTENERS

    // ======================================
    // 🧭 SUBSCRIPTION WIDGET INITIALIZATION
    // ======================================

    /**
     * Initializes the Recharge subscription widget inside a given DOM context.
     * This works for both product pages and featured product sections on non-product pages.
     */
    function initSubscriptionWidgetIfNeeded(context = document) {
    const subscriptionElement = context.querySelector('.subscription-options');
    if (subscriptionElement) {
        console.log('[Subscription Widget] Initializing in context:', context);

        // Run your existing Recharge widget setup
        initializeRechargeWidget();

        // Handle variant logic if needed
        if (hasMultipleVariants()) {
        context.querySelectorAll('[data-variant-input]').forEach(variantInput => {
            variantInput.addEventListener('change', handleVariantChange);
        });
        checkInitialVariant();
        }

        // Select the first subscription option by default
        const firstSelectedDiv = context.querySelector('.option.selected');
        if (firstSelectedDiv) {
        const inputId = firstSelectedDiv.querySelector('input[type="radio"]')?.id;
        if (inputId) selectOption(firstSelectedDiv, inputId);
        }
    }
    }

    /**
     * Handles initialization for product pages.
     * On non-product pages, falls back to initializing any featured-product sections.
     */
    document.addEventListener('DOMContentLoaded', () => {
    if (typeof ShopifyAnalytics !== 'undefined' &&
        ShopifyAnalytics.meta &&
        ShopifyAnalytics.meta.product) {
        console.log('[Subscription Widget] Product page detected.');
        initSubscriptionWidgetIfNeeded(document);
    } else {
        console.log('[Subscription Widget] Not a product page — checking sections.');
        initSubscriptionWidgetIfNeeded(document);
    }
    });

    /**
     * Handles initialization for dynamically loaded Shopify sections (theme editor, AJAX loads, etc.).
     */
    document.addEventListener('shopify:section:load', (e) => {
    console.log('[Subscription Widget] Section load detected:', e.target);
    initSubscriptionWidgetIfNeeded(e.target);
    });

    document.addEventListener('shopify:section:select', (e) => {
    console.log('[Subscription Widget] Section select detected:', e.target);
    initSubscriptionWidgetIfNeeded(e.target);
    });

    /**
     * Debugging listener for cart refresh events.
     */
    document.addEventListener('cart:refresh', () => {
    console.log('[Subscription Widget] cart:refresh event was triggered!');
    });



//HELPER FUNCTIONS

    // Helper function to format money without trailing zeros
    function formatMoneyWithoutTrailingZeros(amountInCents) {
        const amount = (amountInCents / 100).toFixed(2); // Convert cents to dollars and round to two decimal places
        return amount.endsWith(".00")
            ? `$${parseInt(amount, 10)}`  // Remove decimal if not needed
            : `$${amount}`;
    }
    
    
    // Helper function for pricing data for each variant
    const subscriptionPricingLookup = {
        '41983546163382': 3100, // Price for US 50ml variant
        '41983546196150': 3800,  // Price for US 100ml variant
        '42532936646838': 4300,  // Price for CA 50ml variant
        '42532936679606': 5200   // Price for CA 100ml variant
    };



//Recharge Widget

    // Initialize Recharge Widget
    function initializeRechargeWidget() {
        console.log('initializeRechargeWidget called');
        if (typeof ShopifyAnalytics !== 'undefined' && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) {
            console.log('ShopifyAnalytics is loaded');
    
            // Check for the default subscription option on page load
            const defaultOption = document.querySelector('input[name="purchase-option"]:checked');
            if (!defaultOption) {
                // If no option is selected, manually set the subscription option as the default
                const subscriptionOption = document.querySelector('input[value="subscription"]');
                if (subscriptionOption) {
                    subscriptionOption.checked = true;
                    console.log('Default subscription option selected.');
                }
            }
    
            setupAddToCartListener();
        } else {
            console.log('ShopifyAnalytics not yet available, retrying...');
            setTimeout(initializeRechargeWidget, 100);
        }
    }
    
    
    // Handle variant changes to update the price fields dynamically
    function handleVariantChange() {
        const selectedVariantId = getSelectedVariantId();
        updatePrices(selectedVariantId);
    }


    // Check if the product has multiple variants
    function hasMultipleVariants() {
        return ShopifyAnalytics.meta.product.variants.length > 1;
    }


    // Check which variant is currently selected on page load
    function checkInitialVariant() {
        if (hasMultipleVariants()) {
            const selectedVariantId = getSelectedVariantId();
            if (selectedVariantId) {
                console.log('Selected Variant ID:', selectedVariantId);
                updatePrices(selectedVariantId);  // Update prices on load based on the selected variant
            } else {
                console.log('No variant selected');
            }
        } else {
            console.log('Single variant product, skipping variant-related updates');
            // No need to call updatePrices for single-variant products
        }
    }
    
    // Update pricing for selected variant (only called for multi-variant products)
    function updatePrices(selectedVariantId) {
        const selectedVariant = ShopifyAnalytics.meta.product.variants.find(v => v.id == selectedVariantId);
    
        if (!selectedVariant) {
            console.error('Selected variant not found in product variants');
            return;
        }
    
        console.log('Selected Variant Object:', selectedVariant);
    
        // Update the product price dynamically
        document.querySelectorAll('.product-price').forEach(element => {
            element.innerText = Shopify?.formatMoney
                ? Shopify.formatMoney(selectedVariant.price, Shopify.money_format)
                : formatMoneyWithoutTrailingZeros(selectedVariant.price);
        });
    
        // Update the subscription upfront pricing based on the variant using the lookup table
        const subscriptionPrice = subscriptionPricingLookup[selectedVariantId] || (
            ['41983546196150', '42532936679606'].includes(selectedVariantId) // Check if it's the second US or CA variant
                ? ShopifyAnalytics.meta.product.metafields?.custom?.subscription_upfront_pricing_variant_2
                : ShopifyAnalytics.meta.product.metafields?.custom?.subscription_upfront_pricing
        );
    
        if (subscriptionPrice) {
            document.querySelectorAll('.subscription-upfront-pricing').forEach(element => {
                element.innerText = Shopify?.formatMoney
                    ? Shopify.formatMoney(subscriptionPrice, Shopify.money_format)
                    : formatMoneyWithoutTrailingZeros(subscriptionPrice);
            });
        } else {
            console.error('Subscription price not found for selected variant');
        }
    }
    
    
    // Handle the selection of purchase options (subscription vs single purchase)
    function selectOption(selectedDiv, inputId) {
        // Unselect all options and uncheck all radios
        document.querySelectorAll('.option').forEach(div => {
            div.classList.remove('selected');
            const radioInput = div.querySelector('input[type="radio"]');
            if (radioInput) {
                radioInput.checked = false; // Ensure radio is unchecked
            }
        });
    
        // Add the 'selected' class to the clicked option
        selectedDiv.classList.add('selected');
    
        // Check the radio button within the clicked option
        const radioButton = selectedDiv.querySelector(`input[type="radio"]`);
        if (radioButton) {
            radioButton.checked = true;  // Ensure radio stays checked
        } else {
            console.error(`Radio button with ID "${inputId}" not found.`);
        }
    }
    
    
    // Set up the Add to Cart button functionality
    function setupAddToCartListener() {
        const addToCartButton = document.getElementById('add-to-cart') || document.getElementById('add-to-cart-modal');
        if (addToCartButton) {
          addToCartButton.removeEventListener('click', addProductToCart);  
          addToCartButton.addEventListener('click', addProductToCart);
            console.log('Event listener added to add-to-cart button');
        } else {
            console.error('Add-to-cart button not found!');
        }
    }
    
    
    // Open the cart drawer
    function openCartDrawer() {
        console.log('Opening the cart drawer...');
        document.dispatchEvent(new CustomEvent('cart:open'));
        console.log('Cart drawer opened via event.');
    }
    
    
    // Add the selected variant and option to the cart setup
    function addProductToCart() {
      console.log('[addProductToCart]: Function was triggered');   
      const currentProductId = getCurrentProductId(); // Retrieve the product ID of the current page
        console.log('Add to Cart button clicked. Current Product ID:', currentProductId);



        const selectedVariantId = getSelectedVariantId() || 'default'; // Assume default if none selected
        const selectedOption = document.querySelector('input[name="purchase-option"]:checked')?.value || 'subscription'; // Default to subscription
        const deliveryFrequency = document.getElementById('delivery-frequency')?.value || '60'; // Default to 60 days if none selected

        // Check if the product has multiple variants
        const hasVariants = hasMultipleVariants();
    
        // Custom upfront price (only for single-variant products)
        const upfrontPrice = !hasVariants && selectedOption === 'subscription'
            ? (calculateUpfrontPrice(currentProductId) || ShopifyAnalytics.meta.product.variants[0].price) // Use lookup or fallback to variant price
            : null;
    
        console.log('Selected variant ID:', selectedVariantId, 'and option:', selectedOption, 'Selected Delivery Frequency:', deliveryFrequency, 'Upfront pricing:', upfrontPrice);
    
        const subscriptionDetails = getSubscriptionDetails(currentProductId, selectedVariantId, selectedOption, deliveryFrequency);
        if (!subscriptionDetails) {
            console.error('No subscription details found for this product and variant combination.');
            return;
        }
    
        // Pass the variantId, planId, and upfrontPrice (only for single-variant products)
        addToCart(subscriptionDetails.variantId, selectedOption === 'subscription', subscriptionDetails.planId, upfrontPrice);

        
    }
    
    
    // Add product to cart
    function addToCart(variantId, isSubscription, sellingPlanId, upfrontPrice) {
        console.log('Starting addToCart process with variantId:', variantId, 'isSubscription:', isSubscription, 'sellingPlanId:', sellingPlanId, 'upfrontPrice:', upfrontPrice);

        // Define currentProductId at the top, ensuring it’s available
        const currentProductId = String(getCurrentProductId()); // Force string for comparison
        console.log('Initial Current Product ID:', currentProductId, 'Type:', typeof currentProductId);
        
        const data = {
            id: variantId,
            quantity: 1,
            ...(isSubscription ? { selling_plan: sellingPlanId } : {}),
            ...(upfrontPrice ? { properties: { _custom_upfront_price: upfrontPrice } } : {}) // Add custom upfront price
        };
        console.log('Payload for adding to cart:', JSON.stringify(data));

        return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        })
        .then(response => response.json())
        .then(data => {
            console.log('Item successfully added to cart:', data);


       // if (isSubscription) {
         //   console.log("🔍 Subscription detected, checking Liquid-based inventory...");
            
           // if (window.inventoryCheckInStock) {
             //   let bonusItemVariantId = null;
               // if (currentProductId === '8144190046390' || currentProductId === '8162147893430') {
                 //   console.log("✅ Adding bonus item: US Alby Body Oil");
                   // bonusItemVariantId = '42227306922166';
                // } else if (currentProductId === '8144192962742' || currentProductId === '8162148909238') {
                   // console.log("✅ Adding bonus item: CA Alby Body Oil");
                //    bonusItemVariantId = '42938034651318';
                //}
        
                //if (bonusItemVariantId) {
                  //  console.log("🛒 Attempting to add bonus item:", bonusItemVariantId);
                    //return addBonusItemToCart(bonusItemVariantId);
                //}
            //} else {
             //   console.log("🚫 Bonus item is out of stock, not adding.");
            //}
        //}


         
          
            return Promise.resolve(data);
    })

          
        .then(data => {
            // Fetch the product data to handle compare_at_price
            const productHandle = data.handle;
            return fetch(`/products/${productHandle}.json`);
            })
            .then(response => response.json())
            .then(productData => {
                const variant = productData.product.variants.find(v => v.id == variantId);
                console.log('Found Product Data:', productData);
        
                // Check if compare_at_price exists and display it
                if (variant && variant.compare_at_price) {
                    displayCompareAtPrice(variant.price, variant.compare_at_price);
                }
          
                // Trigger necessary events
                document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
                document.dispatchEvent(new CustomEvent('cart:open'));
        
                // Optionally log the current cart drawer content
                const cartDrawer = document.querySelector('.drawer__inner');
                console.log('Current cart drawer content:', cartDrawer ? cartDrawer.innerHTML : 'Cart drawer not found');
        
                return fetch('/cart.js');
        })
        .then(response => response.json())
        .then(updatedCartData => {
            console.log('Step 6: Updated cart data:', updatedCartData);
            openCartDrawer();  // No need to fetch and display compare_at_price here
        })
        .catch(error => {
            console.error('Error during add to cart process:', error);
        });
      }
    


//LOOKUP TABLES & UTILITY FUNCTIONS

    // Upfront pricing for GH Kits
    function calculateUpfrontPrice(variantId) {
    const upfrontPricingLookup = {
        '4786101649492': 13000, // Custom upfront price for US GH Kits
        '7727185756342': 17500,  // Custom upfront price for CA GH Kits
        '7727185756342': 16000,  // Custom upfront price for US GH Kit Deluxe
        '7727185756342': 22400  // Custom upfront price for CA GH Kit Deluxe
    };
    return upfrontPricingLookup[variantId] || null; // Return custom price or null if not defined
}

    // Convert variant value to variant ID
    function convertValueToVariantId(value) {
        const currentProductId = getCurrentProductId();  // Use the existing function to get current product ID
        if (!currentProductId) {
            console.error('Product ID not found');
            return null;
        }

        // Variant mapping for each product
        const variantMapping = {
            // US Lubricant
            '7466285170870': {
              "50ml": "41983546163382",
              "100ml": "41983546196150"
            },
            // CA Lubricant
            '7727191130294': {
              "50ml": "42532936646838",
              "100ml": "42532936679606"
            },
        };

        // Check if there's a mapping for the current product
        const productVariantMapping = variantMapping[currentProductId];
        if (!productVariantMapping) {
            console.error('No variant mapping found for this product');
            return null;
        }

        // Return the variant ID for the selected value
        return productVariantMapping[value] || null;
    }
    

    // Get subscription details for a given product and variant
    function getSubscriptionDetails(productId, variantId, selectedOption, deliveryFrequency) {
      
      const subscriptionMapping = {
            // US GH Kit
            '4786101649492': {
                'default': {
                    'subscription': { variantId: '38054189105334', planId: '3747020982' },
                    'single': { variantId: '38054189105334' }
                }
            },
            // CA GH Kit
            '7727185756342': {
                'default': {
                    'subscription': { variantId: '42532919771318', planId: '3775070390' },
                    'single': { variantId: '42532919771318' }
                }
            },
            // US GH Kit + Moisturizer
            '8162147893430': {
                'default': {
                    'subscription': { variantId: '43829085864118', planId: '3985768630' },
                    'single': { variantId: '43829085864118' }
                }
            },
            // CA GH Kit + Moisturizer
            '8162148909238': {
                'default': {
                    'subscription': { variantId: '43829091303606', planId: '3985801398' },
                    'single': { variantId: '43829091303606' }
                }
            },
            // US Lubricant
            '7466285170870': {
                '41983546163382': { //50ml
                    'subscription': { variantId: '41983546163382', planId: deliveryFrequency === '30' ? '3738861750' : deliveryFrequency === '60' ? '3738894518' : '3700621494' },
                    'single': { variantId: '41983546163382' }
                },
                '41983546196150': { //100ml
                    'subscription': { variantId: '41983546196150', planId: deliveryFrequency === '30' ? '3744301238' : deliveryFrequency === '60' ? '3744334006' : '3744366774' },
                    'single': { variantId: '41983546196150' }
                }
            },
            // CA Lubricant
            '7727191130294': {
                '42532936646838': { //50ml
                    'subscription': { variantId: '42532936646838', planId: deliveryFrequency === '30' ? '3739091126' : deliveryFrequency === '60' ? '3700687030' : '3739123894' },
                    'single': { variantId: '42532936646838' }
                },
                '42532936679606': { //100ml
                    'subscription': { variantId: '42532936679606', planId: deliveryFrequency === '30' ? '3744432310' : deliveryFrequency === '60' ? '3744465078' : '3744399542' },
                    'single': { variantId: '42532936679606' }
                }
            },
            // US Alby
            '7592713158838': {
                'default': {
                    'subscription': { variantId: '42227306922166', planId: deliveryFrequency === '30' ? '3701833910' : deliveryFrequency === '60' ? '3738960054' : '3738992822' },
                    'single': { variantId: '42227306922166' }
                }
            },
            // CA Alby
            '7855902359734': {
                'default': {
                    'subscription': { variantId: '42938034651318', planId: deliveryFrequency === '30' ? '3739189430' : deliveryFrequency === '60' ? '3739156662' : '3739222198' },
                    'single': { variantId: '42938034651318' }
                }
            },
            // US Creme de la Vie
            '8144190046390': {
                'default': {
                    'subscription': { variantId: '43748900602038', planId: deliveryFrequency === '30' ? '3977281718' : deliveryFrequency === '60' ? '3977314486' : '3977347254' },
                    'single': { variantId: '43748900602038' }
                }
            },
            // CA Creme de la Vie
            '8144192962742': {
                'default': {
                    'subscription': { variantId: '43748920557750', planId: deliveryFrequency === '30' ? '3977543862' : deliveryFrequency === '60' ? '3977478326' : '3977511094' },
                    'single': { variantId: '43748920557750' }
                }
            },
        };
        return subscriptionMapping[productId][variantId][selectedOption];
    }
    
    
    // Get selected variant ID
    function getSelectedVariantId() {
        const selectedVariantInput = document.querySelector('[data-variant-input]:checked');
        if (selectedVariantInput) {
            return convertValueToVariantId(selectedVariantInput.value);
        } else if (!hasMultipleVariants()) {
            return 'default';
        } else {
            return null;
        }
    }
    
    
    // Get current product ID
    function getCurrentProductId() {
        return ShopifyAnalytics.meta.product.id || null;
    }    


    // Helper function to add bonus item
    function addBonusItemToCart(variantId) {
        const bonusData = {
            id: variantId,
            quantity: 1,
            properties: { _bonus_item: true } // Mark as a bonus item
        };
    
        return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(bonusData)
        })
        .then(response => response.json())
        .then(data => {
            console.log('Bonus item added to cart:', data);
            return data; // Return data to continue the promise chain
        })
        .catch(error => {
            console.error('Error adding bonus item:', error);
            throw error; // Re-throw to handle in the main chain
        });
    }

    //Helper function to check if Alby is in stock    
    function checkInventory() {
        console.log("📦 Checking inventory from Liquid:", window.inventoryCheckInStock);
    
        return new Promise((resolve) => {
            resolve(window.inventoryCheckInStock);
        });
    }



      // Handling quickview add to cart
      document.addEventListener('DOMContentLoaded', function() {
        // Store the last opened quickview product
        window.lastQuickViewProduct = null;
        
        // Add a single global click handler for any add-to-cart-modal button
        document.addEventListener('click', function(event) {
          // Find if the clicked element is our add-to-cart button or a child of it
          const addToCartButton = event.target.closest('#add-to-cart-modal');
          
          if (addToCartButton) {
            // Prevent default behavior
            event.preventDefault();
            event.stopPropagation();
            
            console.log("[Global Handler]: Add to cart modal button clicked");
            
            // Use the stored product data from the most recent quickview
            if (window.lastQuickViewProduct && window.QuickViewProducts) {
              // Set the correct product context
              ShopifyAnalytics.meta.product = window.QuickViewProducts[window.lastQuickViewProduct];
              console.log(`[Global Handler]: Using context for product: ${window.lastQuickViewProduct}`);
              
              // Call the add to cart function
              addProductToCart();
            } else {
              console.error("[Global Handler]: No product context available");
            }
            
            return false;
          }
        }, true); // Use capture phase to ensure this runs before other handlers
      });
      
      // Simplified openQuickShop that just stores the product context
      function openQuickShop(productHandle) {
        console.log("[openQuickShop]: Called with productHandle=", productHandle);
        
        // Store this as the current quickview product
        window.lastQuickViewProduct = productHandle;
        console.log("[openQuickShop]: Set as current quickview product:", productHandle);
        
        // Ensure ShopifyAnalytics exists
        window.ShopifyAnalytics = window.ShopifyAnalytics || {};
        ShopifyAnalytics.meta = ShopifyAnalytics.meta || {};
        
        // Retrieve product data
        const productData = window.QuickViewProducts?.[productHandle];
        if (!productData) {
          console.error("[openQuickShop]: No quick view data found for handle:", productHandle);
          return;
        }
        
        // Set ShopifyAnalytics
        ShopifyAnalytics.meta.product = productData;
        console.log("[openQuickShop]: ShopifyAnalytics.meta.product set to product data");
        
        // Initialize your Recharge widget code
        initializeRechargeWidget();
      }



    // Display "compare at" price for a cart item
    function displayCompareAtPrice(item, compareAtPrice) {
        const compareAtPriceInCents = Number(compareAtPrice) * 100;
        console.log("compareAtPriceInCents:", compareAtPriceInCents);
        console.log("item.price:", item.price);
    
        // Ensure valid compareAtPrice and that it's greater than item price
        if (!isNaN(compareAtPriceInCents) && compareAtPriceInCents > item.price) {
            const cartItem = document.querySelector(`[data-key="${item.key}"]`);
    
            if (cartItem) {
                const priceElement = cartItem.querySelector('.cart__item-price-col');
                if (priceElement) {
                    const formattedCompareAtPrice = Shopify?.formatMoney
                        ? Shopify.formatMoney(compareAtPriceInCents, Shopify.money_format)
                        : `$${(compareAtPriceInCents / 100).toFixed(2)}`;
    
    
                    const formattedPrice = Shopify?.formatMoney
                        ? Shopify.formatMoney(item.price, Shopify.money_format)
                        : `$${(item.price / 100).toFixed(2)}`;
    
                    priceElement.innerHTML = 
                        `<small class="cart__price cart__price--strikethrough">
                            ${formattedCompareAtPrice}
                        </small>
                        <span class="cart__price cart__discount">
                            ${formattedPrice}
                        </span>`
                    ;
                } else {
                    console.error("Price element not found for cart item.");
                }
            } else {
                console.error("Cart item not found for key:", item.key);
            }
        }
    }